<p-table #dt stripedRows [size]="size" [value]="lines" [lazy]="lazy" [lazyLoadOnInit]="lazyLoadOnInit"
    [loading]="loading" [scrollable]="true" [paginator]="paginator" [rows]="100"
    [rowsPerPageOptions]="[25, 50, 100, 500, 1000]" [scrollable]="true" [totalRecords]="totalRecords"
    (onLazyLoad)="onLazyLoad($event)" rowGroupMode="subheader" groupRowsBy="accountEntry.id"
    [resizableColumns]="true" columnResizeMode="expand" (onColResize)="onColResize($event)" [reorderableColumns]="true" (onColReorder)="onColReorder($event)">

    <!-- Titre du tableau -->
    <ng-template [pTemplate]="showTitle ? 'caption':''">
        <div class="flex align-items-center justify-content-between">
            <!-- Actions à gauche -->
            <div class="flex align-items-center">
                <span class="m-0 text-2xl mr-3">Écritures comptables</span>

                @if (showFilters) {
                <!-- Bouton pour recharger la liste -->
                <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" (click)="onClickRefresh()"
                    pTooltip="Recharger les données" showDelay="500" hideDelay="300"></p-button>
                }
                <!-- Bouton de partage de la vue -->
                @if (shareable) {
                <app-table-share-button></app-table-share-button>
                }
            </div>

            <!-- Actions à droite -->
            @if (showActions) {
            <div class="flex align-items-center gap-3">
                <p-button label="Exporter" icon="pi pi-file-export" severity="primary" [rounded]="true"
                    (click)="onClickExport()"></p-button>
                <p-button label="Historique des exports" icon="pi pi-history" severity="primary" [rounded]="true"
                    [outlined]="true" [routerLink]="appService.clientUrl('/accounting/journals/exports')"></p-button>
            </div>
            }
        </div>

        <!-- Barre de filtres -->
        @if (showFilters) {
        <div class="mt-3">
            <app-account-entries-table-filters>
            </app-account-entries-table-filters>
        </div>
        }
    </ng-template>

    <!-- Ligne d'entête -->
    <ng-template #header>

        <!-- Nom des colonnes -->
        <tr>
            @for (col of visibleColumns; track col.field) {
            @if (col.sortField) {
            <th pResizableColumn pReorderableColumn [ngClass]="col.headerClass" [attr.data-field]="col.field"
                [style.width]="col.columnWidth ? col.columnWidth + 'px' : null"
                [pSortableColumn]="col.sortField">
                {{col.header}} <p-sortIcon class="ml-1" [field]="col.sortField"></p-sortIcon>
            </th>
            } @else {
            <th pResizableColumn pReorderableColumn [ngClass]="col.headerClass" [attr.data-field]="col.field"
                [style.width]="col.columnWidth ? col.columnWidth + 'px' : null">{{col.header}}</th>
            }
            }
            @if (showNavs) {
            <th style="min-width: 3rem"></th>
            }
            <th class="text-center w-4rem">
                <p-button icon="pi pi-cog" [rounded]="true" [text]="true" size="small"
                    (click)="onClickColumnPicker($event)" pTooltip="Gérer les colonnes" showDelay="1000" hideDelay="300">
                </p-button>
            </th>
        </tr>
    </ng-template>

    <ng-template #groupheader let-line>
        <tr pRowGroupHeader>
            @if (showSeparators) {
            <td [attr.colspan]="showNavs ? 17 : 16" class="first-row"></td>
            }
        </tr>
    </ng-template>

    <ng-template #groupfooter let-line>
        <tr pRowGroupHeader>
            @if (showSeparators) {
            <td [attr.colspan]="showNavs ? 17 : 16" class="last-row"></td>
            }
        </tr>
    </ng-template>

    <!-- Données -->
    <ng-template #body let-line>
        <tr [class.row-highlighted]="isHighlighted(line)" [attr.data-highlighted]="isHighlighted(line)">
            @for (col of visibleColumns; track col.field) {
            @switch (col.field) {
            @case ('postingDate') {
            <td [ngClass]="col.cellClass">
                {{ line.accountEntry.postingDate | date:'shortDate' }}
            </td>
            }
            @case ('account') {
            <td [ngClass]="col.cellClass">
                @if (!!line.auxiliaryAccount) {
                <a [routerLink]="[appService.clientUrl('/accounting/account'), line.auxiliaryAccount.id]" class="no-underline hover:underline"
                    (click)="stopPropagation($event)">{{
                    line.auxiliaryAccount.account }}</a>
                } @else {
                <a [routerLink]="[appService.clientUrl('/accounting/account'), line.account.id]" class="no-underline hover:underline"
                    (click)="stopPropagation($event)">{{ line.account.account }}</a>
                }
            </td>
            }
            @case ('accountLabel') {
            <td [ngClass]="col.cellClass">
                @if (!!line.auxiliaryAccount) {
                {{ line.auxiliaryAccount.label }}
                } @else {
                {{ line.account.label }}
                }
            </td>
            }
            @case ('debit') {
            <td [ngClass]="col.cellClass">
                @if (line.debitCredit.code === 'debit') {
                <span>{{line.amountOrg | currency:appService.selectedClient!.currency.code:'code'}}</span>
                }
            </td>
            }
            @case ('credit') {
            <td [ngClass]="col.cellClass">
                @if (line.debitCredit.code === 'credit') {
                <span>{{line.amountOrg |
                    currency:appService.selectedClient!.currency.code:'code'}}</span>
                }
            </td>
            }
            @case ('label') {
            <td [ngClass]="col.cellClass">
                {{ line.label }}
            </td>
            }
            @case ('reference') {
            <td [ngClass]="col.cellClass">
                {{ line.reference }}
            </td>
            }
            @case ('journal') {
            <td [ngClass]="col.cellClass">
                {{ line.accountEntry.journal.code }}
            </td>
            }
            @case ('lettering') {
            <td [ngClass]="col.cellClass">
                {{ line.lettering }}
            </td>
            }
            @case ('letteringDate') {
            <td [ngClass]="col.cellClass">
                {{ line.letteringDate | date:'shortDate' }}
            </td>
            }
            @case ('amount') {
            <td [ngClass]="col.cellClass">
                {{ line.amount | currency:line.currency.code:'code' }}
            </td>
            }
            @case ('operationDate') {
            <td [ngClass]="col.cellClass">
                {{ line.accountEntry.operationDate | date:'shortDate' }}
            </td>
            }
            }
            }
            @if (showNavs) {
            <td>
                <p-button icon="pi pi-external-link" pTooltip="Voir la pièce" tooltipPosition="left" [text]="true"
                    [rounded]="true" (click)="onClickLine(line)"></p-button>
            </td>
            }
            <td></td>
        </tr>
    </ng-template>

    <!-- Pied de tableau -->
    <ng-template #footer>
        @if (lines.length > 0 && showTotals) {
        <tr>
            <td [attr.colspan]="3"></td>
            <td class="text-right text-lg font-bold">{{totalDebit | currency:appService.selectedClient?.currency?.code:
                'code'}}</td>
            <td class="text-right text-lg font-bold">{{totalCredit | currency:appService.selectedClient?.currency?.code:
                'code'}}</td>
            <td [attr.colspan]="showNavs ? 12 : 11"></td>
        </tr>
        }
    </ng-template>

    <!-- Message pour liste vide -->
    <ng-template #emptymessage>
        <tr>
            <td [attr.colspan]="visibleColumns.length + 1">Aucune écriture à afficher</td>
        </tr>
    </ng-template>

</p-table>

<p-popover #columnPickerPopover (onHide)="onColumnPickerHide()">
    <app-table-column-picker [columns]="columns" (onChangeColumnsConfig)="onChangeColumnsConfig($event)">
    </app-table-column-picker>
</p-popover>